// extracted by mini-css-extract-plugin
export var image = "line-item-module--image--3f36f";
export var imageWrapper = "line-item-module--imageWrapper--231af";
export var lineItem = "line-item-module--lineItem--296e5";
export var loader = "line-item-module--loader--10825";
export var price = "line-item-module--price--c3678";
export var productDiscount = "line-item-module--productDiscount--d5568";
export var removeButton = "line-item-module--removeButton--0ef5c";
export var title = "line-item-module--title--f7483";
export var unusedPrice = "line-item-module--unusedPrice--2a597";